const React = require('react');

class MiniQuiz extends React.PureComponent {
  constructor(...args) {
    super(args);

    this.state = {
      quizData: null,
      answerText: '',
      answerPosition: null,
      choosen: false,
    };

    this.frontImage = React.createRef();
    this.backImage = React.createRef();

    this.fetchData = this.fetchData.bind(this);
    this.chooseAnswer = this.chooseAnswer.bind(this);
    this.checkAnswer = this.checkAnswer.bind(this);
    this.answersRender = this.answersRender.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { id, sessionId } = this.props;

    fetch(`/api/v1/mini-quizes/${id}/?respondent_session_id=${sessionId}`)
      .then((response) => response.json())
      .then((quizData) => {
        this.setState({ quizData });
      })
      .then(this.checkAnswer);
  }

  checkAnswer() {
    const { quizData } = this.state;
    const { sessionId } = this.props;
    const answers = JSON.parse(localStorage.getItem('mini_quize_answers')) || [];
    if (quizData.is_answered) {
      const chosenAnswer = answers.find((item) => Number(item.quizId) === Number(quizData.id));
      if (chosenAnswer) {
        fetch(`/api/v1/mini-quizes/${quizData.id}/answer-options/${chosenAnswer.answerId}/?respondent_session_id=${sessionId}`)
          .then((response) => response.json())
          .then((answer) => {
            this.answersRender(answer, quizData.id);

            this.setState({ choosen: true, answerPosition: answer.position });
          });
      } else {
        this.setState({ choosen: true, answerPosition: null });
        this.answersRender(null);
      }
    }
  }

  chooseAnswer(answer) {
    const {
      quizData: { id: quizId },
      choosen,
    } = this.state;
    const { sessionId } = this.props;

    if (choosen) return;

    fetch(
      `/api/v1/mini-quizes/${quizId}/answer-options/respond/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({
          respondent_session_id: sessionId,
          chosen_option: answer.id,
        }),
      },
    )
      .then((response) => response.json())
      .then((newQuizData) => {
        this.answersRender(answer, quizId);

        let answers = JSON.parse(localStorage.getItem('mini_quize_answers')) || [];
        answers.push({ quizId, answerId: answer.id });
        if (answers.length > 100) {
          answers = this.answers.shift();
        }
        localStorage.setItem('mini_quize_answers', JSON.stringify(answers));

        this.setState({
          quizData: newQuizData,
          choosen: true,
          answerPosition: answer.position,
        });
      });
  }

  answersRender(answer, quizId) {
    this.frontImage.current.parentNode.parentNode.classList.add('flipped');

    this.backImage.current.src = answer.image;

    const chosenElement = document.querySelector(
      `.mini-quiz-item-${quizId} .mini-quiz__answers-item-${answer.position}`,
    );

    if (answer.correct_answer) {
      chosenElement.classList.add('success');
    } else {
      chosenElement.classList.add('fail');

      this.setState({
        answerText:
          answer.formatted_answer_comment,
      });
    }

    const answers = document.querySelectorAll(
      `.mini-quiz-item-${quizId} .mini-quiz__answers-item`,
    );

    answers.forEach((item) => {
      item.classList.add('choosen');
    });
  }

  render() {
    const {
      quizData, answerText, answerPosition, choosen,
    } = this.state;
    const { isMobile } = this.props;

    if (!quizData) return null;

    return (
      <div className="mini-quiz">
        <p className="mini-quiz__title">{quizData.title}</p>

        <div className="container-flipcard">
          <div className="block-flipcard">
            <div className="flipcard">
              <div className="front face min-height-block">
                <img
                  className="mini-quiz__image"
                  src={quizData.image}
                  alt={quizData.title}
                  ref={this.frontImage}
                />
              </div>

              <div className="back face">
                <img
                  className="mini-quiz__image"
                  src=""
                  alt={quizData.title}
                  ref={this.backImage}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="mini-quiz__question"
          dangerouslySetInnerHTML={{ __html: quizData.formatted_description }}
        />

        <div className="mini-quiz__answers">
          {quizData.answer_options.map((answer) => (
            // eslint-disable-next-line
            <div
              key={answer.id}
              className="mini-quiz__answers-item__wrapper"
              onClick={() => this.chooseAnswer(answer)}
            >
              <div
                className={`mini-quiz__answers-item mini-quiz__answers-item-${answer.position}`}
              >
                {answer.answer_text}
              </div>

              <div className="mini-quiz__percent" style={{ marginTop: choosen && answerPosition === null && isMobile ? 24 : 'inherit' }}>
                <p
                  className={
                    choosen
                      ? 'mini-quiz__percent--visible'
                      : 'mini-quiz__percent--hidden'
                  }
                >
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {answerPosition !== null
                    ? answer.position === answerPosition ? (
                      <span
                        className={
                                answer.correct_answer
                                  ? 'mini-quiz__percent--correct'
                                  : 'mini-quiz__percent--wrong'
                              }
                      >
                        {answer.responses_percent_from_total}
                        % согласны с вами
                      </span>
                    ) : (
                      <span className="mini-quiz__percent--wrong">
                        {answer.responses_percent_from_total}
                        % считают иначе
                      </span>
                    )
                    : (
                      <span className="mini-quiz__percent--wrong">
                        {answer.responses_percent_from_total}
                        % считают так
                      </span>
                    )}
                </p>
              </div>
            </div>
          ))}
        </div>

        {choosen && <div className="mini-quiz__answer-text" dangerouslySetInnerHTML={{ __html: answerText }} />}
      </div>
    );
  }
}

module.exports = MiniQuiz;
